import styled, { css } from 'styled-components'
import { desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Section = styled.section(
    ({ theme }) => css`
        position: relative;
        overflow: hidden;
        width: inherit;
        padding: ${theme.spacing.xSmall} 0;
        margin-top: 16px;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-top: 8px;
            padding: ${theme.spacing.xLarge} ${theme.spacing.large} ${theme.spacing.medium};
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: ${theme.spacing.xLarge} 4rem ${theme.spacing.large};
        }
    `,
)

export const InnerContainer = styled.div(
    ({ theme }) => css`
        margin-top: ${theme.spacing.xSmall};

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-top: ${theme.spacing.medium};
        }
    `,
)
